import React from 'react';

const AppContext = React.createContext();

const { Provider, Consumer } = AppContext;
export { Provider, Consumer, AppContext };
